var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center flex-wrap gap-1"},_vm._l((_vm.icons),function(ref,id){
var icon = ref.icon;
var label = ref.label;
return _c('Illustration',{key:id,attrs:{"alt":label,"height":24,"src":_vm.$static(icon),"width":36}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }